import { format, formatDistanceToNow } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

const getBrowserTimezone = (): string =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;

export function resolveTz(tz: string | null | undefined): string {
  return tz && tz.trim() ? tz.trim() : getBrowserTimezone();
}

export function formatInTz(
  date: string | number | Date,
  formatStr: string,
  tz: string | null | undefined
): string {
  const resolved = resolveTz(tz);
  try {
    return formatInTimeZone(
      typeof date === 'string' ? new Date(date) : date,
      resolved,
      formatStr
    );
  } catch {
    return format(typeof date === 'string' ? new Date(date) : date, formatStr);
  }
}

export function formatDistanceInTz(
  date: string | number | Date,
  options?: { addSuffix?: boolean }
): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return formatDistanceToNow(d, options);
}

export function toLocaleDateStringInTz(
  date: string | number | Date,
  tz: string | null | undefined,
  locales?: string | string[],
  options?: Intl.DateTimeFormatOptions
): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  const resolved = resolveTz(tz);
  return d.toLocaleDateString(locales, { ...options, timeZone: resolved });
}

export function toLocaleStringInTz(
  date: string | number | Date,
  tz: string | null | undefined,
  locales?: string | string[],
  options?: Intl.DateTimeFormatOptions
): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  const resolved = resolveTz(tz);
  return d.toLocaleString(locales, { ...options, timeZone: resolved });
}

export function toLocaleTimeStringInTz(
  date: string | number | Date,
  tz: string | null | undefined,
  locales?: string | string[],
  options?: Intl.DateTimeFormatOptions
): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  const resolved = resolveTz(tz);
  return d.toLocaleTimeString(locales, { ...options, timeZone: resolved });
}
